/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { Typography } from "@mui/material";

const DataTableComponentEditor = () => {
    
    return (
        <div className="simplicity-data-table-editor">
            <Typography variant="h6">
                Data Table Component
            </Typography>
        </div>
    );
};

DataTableComponentEditor.displayName = "DataTableComponentEditor";
export { DataTableComponentEditor };
